import { IconCloseCircle } from '@blockchain-com/icons'
import { CeruleanButton } from 'components/Button'
import I18n from 'components/I18n'
import Icon from 'components/Icons/Icon'
import Modal from 'components/Modal'
import { selectors } from 'data'
import messages from 'lang'
import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { color, isCompact, screenWidth } from 'utils'

import EUSanctions from './EUSanctions'

const Wrapper = styled(Modal)`
  width: 540px;
  background: ${color('dark800')};
  border-radius: 0.5rem;
  padding: 2.5rem;
  display: grid;
  align-items: flex-end;

  @media only screen and (max-width: ${screenWidth('sm')}) {
    width: 80%;
    padding: 1rem;
  }
`

type SanctionsModalProps = {
  onDone: () => void
}

const EligibilityModal = ({ onDone }: SanctionsModalProps) => {
  const screenWidth = useSelector(selectors.app.getScreenWidth)
  const smallScreen = isCompact(screenWidth)
  return (
    <Wrapper>
      {!smallScreen && (
        <Icon color='dark600' size='lg'>
          <IconCloseCircle onClick={onDone} />
        </Icon>
      )}
      <EUSanctions>
        <I18n data={messages.account_restricted_desc} />
      </EUSanctions>
      <CeruleanButton onClick={onDone} style={{ borderRadius: '8px' }}>
        <I18n data={messages.button_ok_understand} />
      </CeruleanButton>
    </Wrapper>
  )
}

export default EligibilityModal
